// src/components/Results.tsx

import React from "react";
import { downloadCSV } from "../utils/utils";
import "../pages/XMLFeedAnalysis.css";

interface ResultsProps {
  missingProducts: { [id: string]: string };
  isProcessingComplete: boolean;
  onReset: () => void;
}

const MAX_DISPLAYED_PRODUCTS = 123;

const Results: React.FC<ResultsProps> = ({
  missingProducts,
  isProcessingComplete,
  onReset,
}) => {
  const handleDownloadCSV = () => {
    downloadCSV(missingProducts);
  };

  if (!isProcessingComplete) {
    return null;
  }

  const totalMissingProducts = Object.keys(missingProducts).length;
  const displayedProducts = Object.entries(missingProducts).slice(
    0,
    MAX_DISPLAYED_PRODUCTS
  );

  // Render reset buttons
  const renderButtons = () => {
    console.log(
      "Total missing products: ",
      Object.keys(missingProducts).length
    );
    return (
      <div className="button-group">
        <button className="reset-button-style" onClick={handleDownloadCSV}>
          Stáhnout CSV
        </button>
        <button onClick={onReset}>Reset</button>{" "}
      </div>
    );
  };

  return (
    <div>
      {totalMissingProducts === 0 ? (
        <p>Žádné produkty nechybí.</p>
      ) : (
        <>
          <p className="supported-feeds">
            Zobrazeno {displayedProducts.length} z celkových{" "}
            {totalMissingProducts} produktů. Pro úplný seznam stáhněte CSV.
          </p>

          {renderButtons()}

          <table>
            <thead>
              <tr>
                <th></th>
                <th>ID</th>
                <th>Název</th>
              </tr>
            </thead>
            <tbody>
              {displayedProducts.map(([id, name], index) => (
                <tr key={id}>
                  <td>{index + 1}.</td>
                  <td>{id}</td>
                  <td>{name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default Results;
